import { useEffect, useState } from 'react';
import { Download, X, Share } from 'lucide-react';

const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem('tm-install-dismissed')) return undefined;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener('beforeinstallprompt', onPrompt);
    // iOS has no beforeinstallprompt — show a hint after a short delay
    let t;
    if (isIOS()) t = setTimeout(() => { setIosHint(true); setShow(true); }, 3000);
    return () => { window.removeEventListener('beforeinstallprompt', onPrompt); if (t) clearTimeout(t); };
  }, []);

  const dismiss = () => { setShow(false); localStorage.setItem('tm-install-dismissed', '1'); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null); dismiss();
  };

  if (!show) return null;
  return (
    <div data-testid="pwa-install-prompt" className="fixed bottom-16 left-3 right-3 sm:left-auto sm:right-4 sm:w-80 z-[70] bg-slate-900 text-white border border-brand shadow-md p-4">
      <button data-testid="pwa-install-dismiss" onClick={dismiss} aria-label="Dismiss" className="absolute top-2 right-2 text-slate-400 hover:text-white"><X size={16} /></button>
      <div className="flex items-start gap-3">
        <div className="shrink-0 bg-brand p-2"><Download size={20} className="text-slate-900" /></div>
        <div>
          <p className="font-display font-semibold uppercase text-sm tracking-tight">Install the TradesMate app</p>
          {iosHint ? (
            <p className="text-xs text-slate-300 mt-1 flex items-center gap-1 flex-wrap">
              Tap <Share size={13} className="inline text-brand" /> <b>Share</b> then <b>“Add to Home Screen”</b>.
            </p>
          ) : (
            <>
              <p className="text-xs text-slate-300 mt-1">Add it to your home screen — full-screen, one tap, works on site.</p>
              <button data-testid="pwa-install-btn" onClick={install} className="mt-2 bg-brand text-slate-900 font-display font-bold uppercase text-xs px-3 py-1.5 hover:bg-[#ff6b33] transition-colors">
                Install app
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
